(function () {
  window.postAddToCart = async function (variantId, frequencyId, options = {}) {
    if (!variantId) return;

    if (window.cartConfig?.limit_free_gift && window.cartConfig.free_gift_available_variant_id) {
      if (String(variantId) === String(window.cartConfig.free_gift_available_variant_id)) {
        alert('Sorry, this product is not available for direct sale.');
        return;
      }
    }

    const payload = { id: parseInt(variantId, 10), quantity: 1 };
    if (frequencyId) payload.selling_plan = parseInt(frequencyId, 10);

    try {
      const formData = new FormData();
      formData.set('id', payload.id);
      formData.set('quantity', payload.quantity);
      if (payload.selling_plan) formData.set('selling_plan', payload.selling_plan);
      formData.set('sections', 'cart-drawer,variant-added');
      formData.set('sections_url', `${window.Shopify?.routes?.root || '/'}variants/${payload.id}`);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      if (!response.ok) throw new Error('Failed to add product to cart');

      const responseJson = await response.json();

      // Get updated cart data
      const cartContent = await (await fetch('/cart.js')).json();

      // Add sections data to cart content
      cartContent.sections = responseJson.sections;

      // Dispatch cart update events
      if (!options.skipEvents) {
        // Find the element that triggered this (for event bubbling)
        const triggerElement = options.triggerElement || document.documentElement;

        triggerElement.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: Object.prototype.hasOwnProperty.call(responseJson, 'items')
                ? responseJson['items']
                : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      }

      // Show cart drawer (legacy behavior for backward compatibility)
      if (!options.skipCartDrawer) {
        await window.CartDrawer?.fetch?.();
        window.CartDrawer?.show?.(false);
      }

      return responseJson;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  };
})();
